import { Container } from "./styles";
import githubIcon from "../../assets/github-icon.svg"
import externalLinkIcon from "../../assets/external-link-icon.svg"
import ScrollAnimation from "react-animate-on-scroll";


export function Portfolio(){
  return(
    <Container id="portfolio">
      <u><h2 className="about-text">my portfolio</h2></u>
      
      <div className="projects">

      <ScrollAnimation animateIn="flipInX">
        <div className="project">
          <header>
          <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
          <div className="project-links">
            <a href="https://github.com/SabadModi/GestureDetection" target="_blank" rel="noreferrer">
              <img src={githubIcon} alt="Visit Github Page" />
            </a>
          </div>
          </header>
          <div className="body">
            <h3>Gesture Detection</h3>
            <p>
              A program that lets you customize pre-defined gestures to different commands of the computer.
              The program lets you do certain commands of your computer without touching a button.
            </p>
          </div>
          <footer>
            <ul className="tech-list">
              <li>Python</li>
              <li>OpenCV</li>
              <li>Mediapipe</li>
              <li>PyAutoGUI</li>
            </ul>
          </footer>
        </div>
      </ScrollAnimation>

      <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
              <a href="https://github.com/SabadModi/MaskAndSocialDistancingDetection" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="Visit Github Page" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Mask and Social Distancing Detector</h3>
              <p>
                This project lets you detect whether people are wearing a mask or not or even if they aren't wearing their mask correctly.
                It also lets you see whether you are social distancing with other people.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Python</li>
                <li>Pytorch</li>
                <li>YoloV5</li>
              </ul>
            </footer>
          </div>
      </ScrollAnimation>

      <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
              <a href="https://github.com/SabadModi/EmotionDetectionForZoom" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="Visit Github Page" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Emotion Detection For Zoom</h3>
              <p>
                This project detects different emotions shown by people in online meetings and shows a summary accordingly. Also shows a lot of different statistics such as average attention span and prominent emotions in the meetings.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Python</li>
                <li>OpenCV</li>
                <li>Mediapipe</li>
                <li>Sklearn</li>
              </ul>
            </footer>
          </div>
      </ScrollAnimation>

      <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
              <a href="https://github.com/SabadModi/Cryptodate" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="Visit Github Page" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Cryptodate</h3>
              <p>
              Cryptodate is a website that everyone can use to invest easily into the Cryptocurrency Market.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>HTML</li>
                <li>Tailwind CSS</li>
                <li>JS</li>
                <li>PHP</li>
                <li>MySQL</li>
              </ul>
            </footer>
          </div>
      </ScrollAnimation>

      <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
              <a href="https://github.com/SabadModi/Ans4Skl" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="Visit Github Page" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Ans4Skl</h3>
              <p>
                Ans4Skl is a Simple-to-use website that aids students in their homework.
                Helps in summarizing a PDF/Website/Text and can also answer any question from it.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Python</li>
                <li>Tensorflow</li>
                <li>Hugging Face Transformers</li>
                <li>Flask</li>
                <li>gTTS</li>
              </ul>
            </footer>
          </div>
      </ScrollAnimation>

      <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
              <a href="https://github.com/SabadModi/BloggingWebsite" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="Visit Github Page" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Blogging Website</h3>
              <p>
                A blogging website I created for my school. This website has a ton of features that includes posting, comments and replies, admins and much more!
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>HTML</li>
                <li>CSS</li>
                <li>PHP</li>
                <li>MySQL</li>
                <li>FontAwesome</li>
              </ul>
            </footer>
          </div>
      </ScrollAnimation>



      </div>
    </Container>
  );
}